
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import CheckoutView from '@Components/CheckoutView/CheckoutView';
import { Spinner } from '@Components/common/Spinner';
import Layout from '@Components/Layout';
import { useAuth } from '@Contexts/AuthContext/Auth.context';
import { GetStaticPropsContext, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, RootState } from 'store';
import { Col, Container, Row } from 'styled-bootstrap-grid';

type Props = {};
const Checkout: NextPage<Props> = () => {
  const { t } = useTranslation('Checkout');
  const { isTokenValid } = useAuth();
  const { firstIsLoading } = useSelector((state: RootState) => state.checkout);
  const {
    checkout: { getCheckoutData },
  } = useDispatch<Dispatch>();

  useEffect(() => {
    if (isTokenValid) {
      getCheckoutData();
    }
  }, [getCheckoutData, isTokenValid]);

  return (
    <Layout seoData={{ title: t('checkout_title') }}>
      <Container>
        {firstIsLoading ? (
          <Row justifyContent="center">
            <Col
              auto
              style={{
                marginTop: '20vh',
              }}
            >
              <Spinner />
            </Col>
          </Row>
        ) : (
          <Fragment>
            <CheckoutView />
          </Fragment>
        )}
      </Container>
    </Layout>
  );
};

 async function _getStaticProps(context: GetStaticPropsContext) {
  return {
    props: {}, // will be passed to the page component as props
  };
}

export default Checkout;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/checkout/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  